export default __webpack_public_path__ + "static/media/baptism3.ab9359fd.jpg";